import React, { Component } from 'react';
import ReactModal from 'react-modal';

import css from './alert-modal.css';

export default class AlertModal extends Component {
    constructor(props) {
        super(props);

        this.onAcceptClick = this.onAcceptClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }

    onAcceptClick() {
        if(this.props.isAcceptDisabled) {
          return;
        }

        if(this.props.onAcceptClick) {
          this.props.onAcceptClick();
        }
        
        if(this.props.shouldCloseModalOnAccept !== false) {
          this.props.closeModal();
        }
    }

    onCancelClick() {
        if(this.props.onCancelClick) {
          this.props.onCancelClick();
        }
        
        this.props.closeModal();
    }

    getParent() {
		return document.querySelector('#root');
	}

	render() {
		return (
            <ReactModal 
                isOpen={this.props.showModal}
                ariaHideApp={false}
                className="zoom-modal-minimal"
                overlayClassName={this.props.overlayClassName}
                parentSelector={this.getParent}
                shouldCloseOnOverlayClick={true}
                shouldFocusAfterRender={false}
            >
                <div 
                    className={"alert-modal cf" + (this.props.className ? ' ' + this.props.className : '')}
                    style={{ width: this.props.width, height: this.props.height, marginLeft: -(this.props.width/2), marginTop: -(this.props.height/2) }}
                >
                    <div className="alert-modal-top-bar"></div>
                    {this.props.children}
                </div>
            </ReactModal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/alert-modal/AlertModal.js